module.exports = __webpack_public_path__ + "static/media/loc1_img30.e22270f4.jpg";